var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { GoalStatus } from 'globals/enums';
export var GET_GOALS_CONTEXT = 'GET_GOALS_CONTEXT';
export var ADD_GOAL_CONTEXT = 'ADD_GOAL_CONTEXT';
export var ADD_CUSTOM_GOAL_CONTEXT = 'ADD_CUSTOM_GOAL_CONTEXT';
export var UPDATE_GOAL_CONTEXT = 'UPDATE_GOAL_CONTEXT';
export var UPDATE_GOAL_ERROR = 'UPDATE_GOAL_ERROR';
export var DELETE_GOAL_CONTEXT = 'DELETE_GOAL_CONTEXT';
/** Rows that are safe to send to the backend:
 *  - saved goals (have a real id, not flagged isNewGoal)
 *  - newly-created goals that haven't been persisted yet (isNewGoal === true, no id)
 * Both are included so the caller can POST/PUT in one shot.
 */
var toPayload = function (rows) {
    return rows.map(function (row) {
        var isNewGoal = row.isNewGoal, newGoalId = row.newGoalId, isEdited = row.isEdited, rest = __rest(row, ["isNewGoal", "newGoalId", "isEdited"]);
        return rest;
    });
};
export var reducer = function (state, action) {
    var _a, _b;
    switch (action.type) {
        case GET_GOALS_CONTEXT: {
            var _c = action.payload, data = _c.data, clearUnsavedGoals = _c.clearUnsavedGoals, filter = _c.filter;
            var unsavedGoals = clearUnsavedGoals
                ? []
                : state.goalsRowsData.filter(function (row) { return row.isNewGoal; });
            var goalsRowsData = __spreadArray(__spreadArray([], unsavedGoals, true), (data || []), true);
            return __assign(__assign({}, state), { deleteRowsData: [], goalsPayload: toPayload(goalsRowsData), isAddingGoal: unsavedGoals.length > 0, goalsRowsData: data || [], goalsFilter: filter || state.goalsFilter });
        }
        case ADD_GOAL_CONTEXT: {
            var newRow = {
                id: '',
                goalType: '',
                goal: '',
                action: '',
                status: 'not_started',
                progress: 0,
                startDate: '',
                targetDate: '',
                notes: '',
                notesList: '[]',
                isNewGoal: true,
                newGoalId: (((_a = state.goalsRowsData[0]) === null || _a === void 0 ? void 0 : _a.newGoalId) || 1) + 1,
            };
            var goalsRowsData = __spreadArray([newRow], state.goalsRowsData, true);
            return __assign(__assign({}, state), { goalsRowsData: goalsRowsData, goalsPayload: toPayload(goalsRowsData) });
        }
        case ADD_CUSTOM_GOAL_CONTEXT: {
            var newRow = {
                id: '',
                goalType: '',
                goal: '',
                action: '',
                status: 'not_started',
                progress: 0,
                startDate: '',
                targetDate: '',
                notes: '',
                notesList: '[]',
                isNewGoal: true,
                isCustomGoal: true,
                newGoalId: (((_b = state.goalsRowsData[0]) === null || _b === void 0 ? void 0 : _b.newGoalId) || 1) + 1,
            };
            var goalsRowsData = __spreadArray([newRow], state.goalsRowsData, true);
            return __assign(__assign({}, state), { goalsRowsData: goalsRowsData, goalsPayload: toPayload(goalsRowsData) });
        }
        case UPDATE_GOAL_CONTEXT: {
            var goalsRowsData = state.goalsRowsData.map(function (data) {
                var _a;
                if ((data.id || data.newGoalId) === action.payload.id) {
                    return __assign(__assign(__assign(__assign(__assign({}, data), (_a = {}, _a[action.payload.name] = action.payload.value, _a.isEdited = true, _a)), (action.payload.name === 'goalType' && !action.payload.isCustomRow && {
                        goalTypeErrorText: '',
                        goalTypeError: false,
                        goal: '',
                    })), (action.payload.name === 'goal' && !action.payload.isCustomRow && {
                        goalErrorText: '',
                        goalError: false,
                        action: '',
                    })), (action.payload.name === 'action' && {
                        actionErrorText: '',
                        actionError: false,
                    }));
                }
                return data;
            });
            return __assign(__assign({}, state), { goalsRowsData: goalsRowsData, goalsPayload: toPayload(goalsRowsData) });
        }
        case UPDATE_GOAL_ERROR: {
            return __assign(__assign({}, state), { goalsRowsData: __spreadArray([], action.payload, true) });
        }
        case DELETE_GOAL_CONTEXT: {
            var isUnsavedNewGoal = action.payload.isNewGoal && !action.payload.id;
            var deleteGoal = isUnsavedNewGoal
                ? null
                : state.goalsRowsData.find(function (data) { return data.id === action.payload.id && !data.isNewGoal; }) || action.payload;
            var goalId = (deleteGoal === null || deleteGoal === void 0 ? void 0 : deleteGoal.id) || (deleteGoal === null || deleteGoal === void 0 ? void 0 : deleteGoal.newGoalId);
            var updatedDeleteGoal = goalId
                ? __assign(__assign({}, deleteGoal), { status: GoalStatus.Deleted }) : null;
            var updatedArray = state.goalsRowsData.filter(function (data) {
                return (data.isNewGoal ? data.newGoalId : data.id) !==
                    (action.payload.id || action.payload.newGoalId);
            });
            return __assign(__assign({}, state), { goalsRowsData: updatedArray, deleteRowsData: updatedDeleteGoal
                    ? __spreadArray([updatedDeleteGoal], state.deleteRowsData, true) : state.deleteRowsData });
        }
        default:
            return state;
    }
};
